import MobileTitleBar from "components/MobileTitleBar"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductCard from "components/Product/ProductCard"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductList from "components/Product/ProductList"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductSearch from "components/Product/ProductSearch"
import ProductSearchExtra from "components/Product/ProductSearchExtra"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import { Col, Row } from "elemental-react16"
import _ from "lodash"
import PropTypes from "prop-types"
import React, { Component, Fragment } from "react"
import Responsive from "react-responsive"
import { Link } from "react-router-dom"
import { Button, Card, Container, Icon, Input, Label, Message, Popup, Select, Table, Image } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import categoryStore from "stores/categoryStore"
import productStore from "stores/productStore"
import "style/ProductPage.scss"
import cmsStore from "stores/cmsStore"
import { ProductDownloads } from "components/ProductDownloads";
import ButtonLove from "components/Button/ButtonLove";
import { SEOProduct } from "../../../components/SEO";
import WordPressShopComponent from "../../../components/WordPressShopComponent/WordPressShopComponent";
import ProductReplacementHints from "../../../components/Product/ProductReplacementHints";

let lastProducts = null

const IconImage = ({ src, description }) => <Popup content={description}
  trigger={<img className="mr2 icon-product-attribute" width="42"
    src={src} alt="" />} />

const ProductThumbnails = ({ product, query = {}, download = true, fullscreen = false }) => {
  return <div className="product-images pt1 flex">
    {product.img_srcs.map((entry, key) => {
      const isActive = key === Number(query.image)
      return <div className="img-container " key={key}>
        <Link
          className={`img-thumbnail ${isActive ? "active" : "not-active"}`} key={entry.img_src_small}
          to={{ pathname: `/product/${product.map_id}`, search: `?image=${key}&fullscreen=${fullscreen ? "1" : "1"}` }}><img src={entry.img_src_small}
            alt="" /></Link>
        <ProductImages
          key={product.map_id}
          product={product} images={product.img_srcs} image={product.productImage}
          onClick={this.showFullscreen}
          onClickSecondary={this.setPrimaryImage} />
        {<a
          download={`${product.article_nr}-${product.title}-${key}.jpg`} // works on same origin
          href={entry.img_src_large}
          className="db ttu pt2 tc black-60 f7  "><Button>download</Button></a>}
      </div>
    })}
  </div>
}

export default class ProductPage extends Component {

  componentWillUnmount() {
    document.body.classList.remove("no-scroll")
  }

  constructor(props) {
    const { match } = props
    super()
    this.state = {
      id: match.params.productId,
      product: {},
      fullscreenElement: null,
      variants: false
    }
  }

  loadProduct(id) {
    if (this.id === id) return
    this.id = id
    productStore.get(id)
      .then(product => {
        console.log("ProductPage::product", product)
        product.count = 1
        let inCart = shop.cart.productsById.get(product.map_id)
        if (inCart) product.count = Number(inCart.count)
        shop.analytics.push(product.map_id)
        track.viewDetails({ product })
        console.log('track pushed');
        lastProducts = shop.analytics.lastProducts(4)
          .filter((id) => id !== product.map_id)
        this.setState({ product: product, primaryImage: false, count: product.count })

        if (!product.mainart) return

        productStore.partlist(product.mainart)
          .then(variants => {
            // let colors = variants.products.map( product => {
            //   return {
            //     color:  product.extras.Farbe,
            //     map_id: product.map_id
            //   }
            // } )

            let byAttribute = {}
            variants.variants.varfields.forEach(varfield => {
              let categories = _.groupBy(variants.products, `extras.${varfield}`)
              var ordered = {};
              _(categories).keys().sort().each(function (key) {
                ordered[key] = categories[key];
              });
              byAttribute[varfield] = ordered

            })
            this.setState({ variants, byAttribute })
          })
      })
      .catch(err => {
        console.error(`Product not available ${id}`)
        console.error(err)
        this.setState({ error: true })
      })
  }

  add = ({ product }) => {
    //if ( product.count === 0 ) return shop.cart.remove( product )
    let ok = shop.cart.add(product)
    if (ok) shop.toast(`${product.count * product.unit_multi} ${translate("Stück")} ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")
    this.updateProduct({ product });
  }

  updateProduct = ({ product }) => {
    this.setState({ product })
  }

  componentWillReceiveProps({ match }) {
    let { productId } = match.params
    this.loadProduct(productId)
  }

  showFullscreen = (element) => {
    this.setState({
      fullscreenElement: element
    })
  }

  setPrimaryImage = (primaryImage) => {
    this.setState({ primaryImage })
  }

  componentDidMount() {
    this.loadProduct(this.state.id)
  }

  render() {
    let { fullscreenElement, product, byAttribute, primaryImage, error } = this.state
    /*
    if (error){
      document.location.href = "/home"
    }*/
   if(error)
    return <div className={"vh-75 tc flex justify-center items-center"}>
      <div>
        <h3>{translate("BrandUnavailable")}</h3>
      </div>
    </div>


    if (!product._type) return null //  duck type check for ProductModel
    let img_srcs = product.img_srcs

    let category = product.cats[0] && product.cats[0] || {}
    let cat_id = category.cat_id

    let productImage
    if (product.img_src) {
      productImage = product.img_src_large
    }

    if (primaryImage) productImage = primaryImage

    // let categoryName = shop.categoryName(product.cats[0].cat_id)
    let path = shop.getCategoryPath(cat_id)

    path.push({
      title: product.title,
      link: ""
    })

    const veOptions = product.quantities.map(q => {
      return (
        {
          key: q.map_desc_id,
          text: `${q.des} (${q.multi})`,
          value: q.map_desc_id
        }
      )
    })

    // const veOptions = [
    //   { key: 'all', text: 'All', value: 'all' },
    //   { key: 'articles', text: 'Articles', value: 'articles' },
    //   { key: 'products', text: 'Products', value: 'products' },
    // ]

    return (
      <div className="bg-white ">
        {/*<SEOProduct product={product} />*/}
        <MobileTitleBar>
          <ProductPath path={path} title={product.title} product={product} />
        </MobileTitleBar>
        <WordPressShopComponent key={`product-${product.map_id}`} slug={`product-${product.map_id}-top`} />
        <Container className="relative  ">
          <ProductFullscreen
            change={this.showFullscreen}
            images={img_srcs}
            image={fullscreenElement}
            product={product} />

          <Responsive minWidth={790}>
            <div className="db pv3 ">
              <ProductPath path={path} title={product.title} product={product} />
            </div>
          </Responsive>

          {/*<Breadcrumbs path={path}/>*/}
          <section className="product product-single pb6-ns pb5">
            <Row>
              <Col sm="1" md="1/2" lg="6/12" className="relative">
                <div className="absolute right-2 pr3"><Badge product={product} /></div>
                {<ProductImages
                  key={product.map_id}
                  product={product} images={img_srcs} image={productImage}
                  onClick={this.showFullscreen}
                  onClickSecondary={this.setPrimaryImage} />}
              </Col>
              <Col sm="1" md="1/2" lg="6/12">

                <TitleSection product={product} />
                <DescriptionSection product={product} />
                {/*{shop.session && <ActionSection product={product}*/}
                {/*onChange={this.updateProduct}*/}
                {/*onAdd={this.add}/>*/}
                {/*}*/}
                {shop.session && <div className="pb2 ">
                  <ProductPrice className={"f2 pt0 relative lh-solid"} product={product} />
                  <div className="pt2 pb2 pt4-ns">
                    <h4>{translate("Verfügbarkeit")}</h4>
                    <div>
                      {product.getNotice()}
                    </div>
                  </div>
                  {(product && product.canBeBought) && <div>
                    {shop.session &&
                      <div className="product-actions">
                        {product && <Fragment>
                          {/*console.log("count: ", this.state.count)*/}
                          {/*<Button icon="minus" onClick={() => {
                                const newCount = Math.max(0, (this.state.count || product.count) - 1);

                                this.setState({ count: newCount });
                                
                                }}/>*/}
                          <Input type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
                            this.setState({ count: e.target.value })
                          }
                          }>
                            <input />
                            {/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
                              onChange={(e, data) => {
                                const { value } = data
                                const ve = product.quantities.filter(q => q.map_desc_id === value)
                                if (!ve) return
                                product.unit_multi = ve[0].multi
                                product.unit_id = ve[0].map_desc_id
                                console.log({ data, e, value: e.target.value, target: e.target })
                              }
                              }
                            />*/}
                            <div className="content-center pl2">
                              {this.state.count} {translate("VE")} {this.state.count * product.unit_multi} {translate("Stk")}
                            </div>

                          </Input>
                        </Fragment>
                        }
                        <div className="pt2 flex flex-row justify-between">
                          <Button style={{ width: "100%" }} primary onClick={() => {
                            product.count = this.state.count || 1
                            console.info("BUY", this.state.count, product.unit_multi, product.unit_id)
                            this.add({ product })
                          }
                          }>
                            <div className="ph3 ph4-ns flex flex-row items-center justify-center">
                              <Icon name={"shopping cart"} />{translate("IN DEN WARENKORB LEGEN")}
                            </div>
                          </Button>
                        </div>
                      </div>}

                  </div>}
                </div>}

                {shop.session && <BulkPricing product={product} />}
                {!shop.session && <div>
                  <p>
                    {translate("shop.please_login_for_product_details")}
                  </p>

                  <div className="mw6">
                    <div className="pb2">
                      {console.log("location", this.props)}
                      <Link to={`/login?referrer=${this.props.location.pathname}`}><Button fluid> {translate("shop.login")}</Button></Link>
                    </div>
                    <Link to="/customer_registration"><Button fluid> {translate("shop.register")}</Button></Link>
                  </div>
                </div>}
                {/*{shop.session && <ProductTechnicalTable product={product} />}*/}


                <ProductReplacementHints key={product.map_id} product={product} />

                <section>
                  <Variants byAttribute={byAttribute} product={product} />
                  {/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
                  {/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
                </section>
                <br />
                <div className="pt3 pt4-ns">
                  <h4>Details</h4>
                  <CustomDisplay product={product} />
                </div>
                {shop.session && <div className="pt3 pt4-ns">
                  <ProductDownloads product={product} />
                </div>}

                <br />
                <br />
              </Col>
            </Row>
          </section>
          {/*	*/}
        </Container>

        {product.extras.Kollektion && <div className="bg-silver pv4">
          <Container>
            <section className=" pt3 pb5">

              <div className="cf relative pb3">
                {product.category.desc &&
                  <Link to={`/collection-extra/Kollektion/${product.extras.Kollektion}`}><h2
                    className="mt2 ttu">{`${translate("Topseller aus Kollektion")}  ${product.extras.Kollektion}`} <Icon
                      name="chevron right" /></h2>
                  </Link>}
              </div>

              <ProductSearchExtra
                count={4}
                start={0}
                extra={"Kollektion"}
                extraValue={product.extras.Kollektion}
                query="%%"
                repeat={ProductCard} />
            </section>

          </Container>
        </div>}


        <div className="bt bb b--black-10">
          <Container>
            {/*Product Slider "last viewed"*/}
            <section className="section-product-slider pv5">
              <h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>
              <ProductList
                count={4}
                start={0}
                list={lastProducts}
                displayMode={"list"}
                repeat={ProductCard} />
            </section>
          </Container>
        </div>
      </div>
    )
  }
}

ProductPage.propTypes = {
  price: PropTypes.any
}

const CustomDisplay = ({ product }) => {
  let primaryCategory = product.category
  let cid = primaryCategory && primaryCategory.cat_id || String(product.category && product.category.map_id)
  let configByCategory = cmsStore.config.orthoFieldProductDetailConfigByCategory[cid] || cmsStore.config.orthoFieldProductDetailConfigByCategory["DEFAULT_EXTENDED"] || {}


  const [translations, setTranslations] = React.useState(false)
  React.useEffect(() => {
    if (!configByCategory || !configByCategory.columns) {
      return setTranslations(true)
    }
    let promises = configByCategory.columns && configByCategory.columns
      .filter(e => e)
      .map(columnKey => {
        categoryStore.loadTranslatedFields({ fieldName: columnKey })
      })

    let translations = Promise.all(promises)
      .then(res => {
        setTranslations(true)
      })

  }, [product])

  if (!translations) return <div>
    LOADING
  </div>

  var hideExtraFields = ["Z_Verpackungseinheit_Anzahl", "katalogsortierung", "neuheit", "sortdes", "articletype", "stockColor", "stockText", "sortDef"]

  return (
    <div>
      <Table basic={"very"}>
        <Table.Body>

          {/*<Table.Row positive >*/}
          {/*	<Table.Cell>product.desc.des</Table.Cell>*/}
          {/*	<Table.Cell><b>{product.desc.des}</b></Table.Cell>*/}
          {/*</Table.Row>*/}

          {/*<Table.Row positive>*/}
          {/*	<Table.Cell>product.desc.short_des</Table.Cell>*/}
          {/*	<Table.Cell><b>{product.desc.short_des}</b></Table.Cell>*/}
          {/*</Table.Row>*/}


          {/*<Table.Row>*/}
          {/*	<Table.Cell>VE</Table.Cell>*/}
          {/*	<Table.Cell><b><span>{product.unit_multi} Stück</span></b></Table.Cell>*/}
          {/*</Table.Row>*/}

          {product.extras.Z_Verpackungseinheit_Anzahl && <Table.Row>
            <Table.Cell>VE </Table.Cell>
            <Table.Cell><b><span>{product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl.text} </span></b></Table.Cell>
          </Table.Row>}
          {product && <Table.Row>
            <Table.Cell>{translate("Artikel-Nr.")}</Table.Cell>
            <Table.Cell><b><span>{product.article_nr} </span></b></Table.Cell>
          </Table.Row>}
          {product && <Table.Row>
            <Table.Cell>{translate("EAN")}</Table.Cell>
            <Table.Cell><b><span>{product.barcode} </span></b></Table.Cell>
          </Table.Row>}
          {product && product.quantities && product.quantities[0] && <Table.Row>
            <Table.Cell>{translate("VE")}</Table.Cell>
            <Table.Cell><b><span>{product.quantities[0].multi}  {translate("Stk.")}{/*product.quantities[0].des*/}</span></b></Table.Cell>
          </Table.Row>}
          {console.log("product.extras", product.extras, Object.keys(product.extras))}

          {/*<Table.Row>*/}
          {/*	<Table.Cell>Verfügbar</Table.Cell>*/}
          {/*	<Table.Cell><b><span>{product.stock} Stück</span></b></Table.Cell>*/}
          {/*</Table.Row>*/}
          {product && product.extras && Object.keys(product.extras).sort()
            .filter(e => hideExtraFields.indexOf(e) < 0)
            .map(columnKey => {
              const valueObject = product.extras[columnKey]
              if (!valueObject) return null
              if (valueObject.value && valueObject.value.text) {
                console.log(columnKey);
                const value = valueObject.value.text
                return <React.Fragment key={columnKey}>
                  <Table.Row>
                    <Table.Cell>{translate(columnKey)}</Table.Cell>
                    <Table.Cell><b>{value || "Kein Wert"}</b></Table.Cell>
                  </Table.Row>
                </React.Fragment>
              }
            })}
        </Table.Body>
      </Table>
    </div>
  )
}

const ProductVariant = ({ product }) => {
  return (
    <Card as={Link} to={`/product/${product.map_id}`}>
      <img className="ui image" src={product.img_src_medium} />
      <div>{product.extras.Art}</div>
      <div>{product.extras.Groesse}</div>
    </Card>
  )
}

const BulkPricing = ({ product }) => {
  if (!product.prices || product.prices.length === 1) return null
  return (

    <div>
      <h4>{translate("Staffelpreise")} </h4>
      <Table>
        <tbody>
          {product.prices.map(price => (
            <tr key={price.q}>
              <td>{translate("ab")} {price.q} {translate("Stück")}</td>
              <td><Price>{price.p}</Price></td>
            </tr>
          ))}
        </tbody>
      </Table>

    </div>
  )
}

const Fullscreen = ({ image, change, images }) => {
  document.body.classList.remove("no-scroll")
  if (!image) {
    return null
  }
  window.scrollTo && window.scrollTo(0, 0)
  const imgs = _.map(images, ({ img_src_large, img_src_small }, key) => {
    return (
      <img key={key}
        onClick={() => {
          change(img_src_large)
        }}
        className="img-thumbnail "
        src={img_src_small} />
    )
  })

  document.body.classList.add("no-scroll")
  return (
    <div className="fullscreen">
      <div className="ui pull-right"
        style={{ position: "relative" }}>
        <Button icon="close"
          basic
          onClick={() => {
            change(false)
          }} />
      </div>

      <div className="center-child "
        onClick={() => {
          change(false)
        }}>
        <div className="zoom-out img-container">
          <img src={image} alt="" />
        </div>
      </div>

      <div className="ui ui-bottom pull-right ">
        <div className="product-images">
          {imgs}
        </div>
      </div>
    </div>
  )
}

Fullscreen.propTypes = {
  children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}

const AdditionalTable = ({ product }) => {
  return (
    <section className="AdditionalTable">
      <Row>
        <Col sm="1" md="1" className="pb3">
          <div className="technischetabelle">
            <strong>weitere Details</strong>
            <table className="table-technical">
              <tbody>
                {product && shop.session.group !== "WERBE" ? <tr>
                  <td>UVP inkl. MwSt.</td>
                  <td className="text-right"><Price className="fw1">{product.extras.evkpre}</Price></td>
                </tr> : null}
                {product && shop.session.group === "WERBE" ? <tr>
                  <td>Industriepreis Netto</td>
                  <td className="text-right"><Price className="fw1">{product.extras.indpre}</Price></td>
                </tr> : null}
                {product ? <tr>
                  <td>EAN</td>
                  <td className="text-right">{product.barcode}</td>
                </tr> : null}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </section>
  )
}

AdditionalTable.propTypes = {
  product: PropTypes.object
}

const TitleSection = ({ product }) => (
  <section className="product-title mb0 pb0">

    <div className="brand">{product.extras.herst !== "unbekannt" &&
      <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>
    <div className="title f3 f3-ns b lh-copy">
      {product.desc.short_des}
      <span className="badges relative right--1 top--1 ">
        {product.extras && product.extras.neuheit && product.extras.neuheit.value && product.extras.neuheit.value.value && <span className="labelNeu1">&nbsp;&nbsp;{translate("Neu")}&nbsp;&nbsp;</span>}
      </span>
    </div>

    {/*<div className="title f1 b lh-copy">{product.desc.des}</div>*/}
    <div className="id pt2 pv2">{translate("Art. Nr.") + ": "}{product.article_nr || product.article_id}</div>

    {product.extras.statusinfo && <Message>{product.extras.statusinfo}</Message>}
    {product.extras.isnew && <Label color={"blue"}>{translate("Achtung Neuheit - nur vorbestellbar")}</Label>}


    {/* Availability*/}
    {/*{shop.config.useAvailability !== false && <Availability product={product} />}*/}
    {/*<Availability product={product}/>*/}

  </section>
)

TitleSection.propTypes = {
  product: PropTypes.object
}

const Availability = ({ product }) => {
  let notice = product.getNotice()
  return (
    <div className="availability">
      {notice}
    </div>
  )
}

const ActionSection = ({ product, onChange, onAdd }) => {
  if (!product.canBeBought) return null
  const list = shop.orderlist.default
  return (
    <section className="product-actions pt2 pb4">
      <div style={{ display: "inline-block " }}>
        <p>
          {product.count * product.unit_multi} Stück <Price
            className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>

        <ProductQuantityGroup product={product}
          list={list}
          showVE={false}
          onChange={onChange}
          onAdd={onAdd}
          large />
      </div>
    </section>
  )
}

ActionSection.propTypes = {
  product: PropTypes.object,
  onChange: PropTypes.func,
  onAdd: PropTypes.func,
}

const DescriptionSection = ({ product }) => (
  <section className="description pt2 fw5 f5 lh-copy">
    {product.desc && product.desc.des && product.desc.des.split('\n').map((line, i) => (<span key={i}>{line}<br /></span>))}
  </section>
)
DescriptionSection.propTypes = {
  product: PropTypes.object,
}


ProductImages.propTypes = {
  images: PropTypes.any,
  image: PropTypes.any,
  onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/mags/pages/ProductPage.js